module.exports = __webpack_public_path__ + "Rectangle-30.png";